import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";
export const typeSlider = blocksOptionsConfig.collectionTypes.sliderV2.value;

export const sliderConfig = newCollectionTemplate({
  typeFields: {
    title: "text",
    description: "textarea",
    image: "image",
    alt: "text",
    link: "text",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: "boolean",
  },
  itemTemplate: {
    title: "",
    description: "",
    image: "",
    link: "",
    alt: "",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: true,
  },
  type: typeSlider,
  showAsTitle: "title", // only texts fields
  allowUseSets: true,
});

// export const sliderConfig1 = {
//   typeFields: {
//     title: "text",
//     description: "textarea",
//     image: "image",
//     alt: "text",
//     link: 'text',
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   itemTemplate: {
//     title: "",
//     description: "",
//     image: "",
//     link: '',
//     alt: "",
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   type: typeSlider,
//   showAsTitle: "title", // only texts fields
//   allowUseSets: true,
// };

export const initBlockData = {
  title: "The most popular destinations",
  collections: {
    [typeSlider]: {
      ...sliderConfig, // TODO: remove this from here and other simular places
      items: [],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig, // TODO: remove this from here and other simular places
      items: [],
    },
  },
};
